
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const serviceDetails = {
  '1': {
    name: 'تمريض منزلي',
    description: 'رعاية طبية متخصصة في منزلك على يد ممرضين محترفين ومؤهلين',
    icon: 'ri-nurse-line',
    color: 'from-[#1565C0] to-[#1976D2]',
    rating: 4.8,
    reviews: 245,
    price: '200',
    image: 'https://public.readdy.ai/ai/img_res/705143f95ed534267e0902d8c2b09392.jpg',
    features: ['رعاية على مدار الساعة', 'ممرضين مؤهلين', 'معدات طبية حديثة', 'متابعة دورية']
  },
  '2': {
    name: 'تنظيف شامل',
    description: 'تنظيف عميق واحترافي لجميع أركان منزلك',
    icon: 'ri-brush-line',
    color: 'from-[#2E7D32] to-[#43A047]',
    rating: 4.9,
    reviews: 312,
    price: '150',
    image: 'https://readdy.ai/api/search-image?query=Professional%20cleaning%20service%20worker%20in%20uniform%20cleaning%20modern%20home%20interior%2C%20cleaning%20supplies%20and%20equipment%2C%20bright%20clean%20space%2C%20high%20quality%20photography%2C%20realistic%20style%2C%20fresh%20atmosphere&width=400&height=400&seq=cleaning3&orientation=squarish',
    features: ['تنظيف شامل', 'مواد تنظيف آمنة', 'فريق محترف', 'ضمان الجودة']
  },
  '3': {
    name: 'سباكة',
    description: 'إصلاح وصيانة جميع أعمال السباكة بكفاءة عالية',
    icon: 'ri-drop-line',
    color: 'from-[#0277BD] to-[#0288D1]',
    rating: 4.7,
    reviews: 189,
    price: '180',
    image: 'https://readdy.ai/api/search-image?query=Professional%20plumber%20fixing%20pipes%20and%20faucets%20in%20modern%20bathroom%2C%20plumbing%20tools%20visible%2C%20clean%20workspace%2C%20high%20quality%20photography%2C%20realistic%20style%2C%20professional%20service&width=400&height=400&seq=plumbing3&orientation=squarish',
    features: ['إصلاح فوري', 'قطع غيار أصلية', 'ضمان الخدمة', 'خبرة عالية']
  }
};

export default function ServiceDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const service = serviceDetails[id as keyof typeof serviceDetails] || serviceDetails['1'];
  
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedTime, setSelectedTime] = useState('');
  const [address, setAddress] = useState('');
  const [description, setDescription] = useState('');
  const [images, setImages] = useState<string[]>([]);

  const timeSlots = ['09:00', '11:00', '13:00', '15:00', '17:00', '19:00'];

  const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files) {
      const newImages = Array.from(files).map(file => URL.createObjectURL(file));
      setImages([...images, ...newImages]);
    }
  };

  const handleSubmit = () => {
    navigate('/price-offers');
  };

  return (
    <div className="min-h-screen bg-[#F6F6F6] pb-24">
      {/* Header Image */}
      <div className="relative h-64">
        <img
          src={service.image}
          alt={service.name}
          className="w-full h-full object-cover object-top"
        />
        <div className={`absolute inset-0 bg-gradient-to-t ${service.color} opacity-30`}></div>
        
        <button
          onClick={() => navigate(-1)}
          className="absolute top-12 right-6 w-10 h-10 bg-white/90 backdrop-blur-sm rounded-xl flex items-center justify-center shadow-lg"
        >
          <i className="ri-arrow-right-line text-[#212121] text-xl"></i>
        </button>

        <button className="absolute top-12 left-6 w-10 h-10 bg-white/90 backdrop-blur-sm rounded-xl flex items-center justify-center shadow-lg">
          <i className="ri-heart-line text-[#212121] text-xl"></i>
        </button>
      </div>

      {/* Service Info */}
      <div className="px-6 -mt-6">
        <div className="bg-white rounded-2xl p-5 shadow-lg animate-slideUp">
          <div className="flex items-start justify-between mb-3">
            <div className="flex-1">
              <h1 className="text-xl font-bold text-[#212121] mb-2">{service.name}</h1>
              <p className="text-gray-600 text-sm mb-3">{service.description}</p>
              
              <div className="flex items-center gap-4">
                <div className="flex items-center gap-1">
                  <i className="ri-star-fill text-[#FBC02D]"></i>
                  <span className="font-bold text-[#212121]">{service.rating}</span>
                  <span className="text-gray-400 text-sm">({service.reviews})</span>
                </div>
                <div className="flex items-center gap-1">
                  <span className="text-[#1565C0] font-bold text-lg">{service.price}</span>
                  <span className="text-gray-400 text-sm">ر.س</span>
                </div>
              </div>
            </div>
          </div>

          {/* Features */}
          <div className="grid grid-cols-2 gap-2 mt-4">
            {service.features.map((feature, index) => (
              <div key={index} className="flex items-center gap-2 bg-[#F6F6F6] rounded-lg p-2">
                <i className="ri-checkbox-circle-fill text-[#2E7D32] text-sm"></i>
                <span className="text-xs text-gray-700">{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Booking Form */}
      <div className="px-6 mt-6">
        {/* Date Selection */}
        <div className="bg-white rounded-2xl p-5 shadow-md mb-4 animate-slideUp stagger-1">
          <h3 className="font-bold text-[#212121] mb-3 flex items-center gap-2">
            <i className="ri-calendar-line text-[#1565C0]"></i>
            اختر التاريخ
          </h3>
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            className="w-full bg-[#F6F6F6] rounded-xl p-3 outline-none text-sm"
          />
        </div>

        {/* Time Selection */}
        <div className="bg-white rounded-2xl p-5 shadow-md mb-4 animate-slideUp stagger-2">
          <h3 className="font-bold text-[#212121] mb-3 flex items-center gap-2">
            <i className="ri-time-line text-[#1565C0]"></i>
            اختر الوقت
          </h3>
          <div className="grid grid-cols-3 gap-2">
            {timeSlots.map((time) => (
              <button
                key={time}
                onClick={() => setSelectedTime(time)}
                className={`py-2 rounded-xl text-sm font-semibold transition-all ${
                  selectedTime === time
                    ? 'bg-[#1565C0] text-white'
                    : 'bg-[#F6F6F6] text-gray-600'
                }`}
              >
                {time}
              </button>
            ))}
          </div>
        </div>

        {/* Address */}
        <div className="bg-white rounded-2xl p-5 shadow-md mb-4 animate-slideUp stagger-3">
          <h3 className="font-bold text-[#212121] mb-3 flex items-center gap-2">
            <i className="ri-map-pin-line text-[#1565C0]"></i>
            العنوان
          </h3>
          <div className="flex gap-2">
            <input
              type="text"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              placeholder="أدخل عنوانك"
              className="flex-1 bg-[#F6F6F6] rounded-xl p-3 outline-none text-sm"
            />
            <button
              onClick={() => navigate('/location')}
              className="w-12 h-12 bg-[#1565C0] rounded-xl flex items-center justify-center"
            >
              <i className="ri-navigation-line text-white"></i>
            </button>
          </div>
        </div>

        {/* Description */}
        <div className="bg-white rounded-2xl p-5 shadow-md mb-4 animate-slideUp stagger-4">
          <h3 className="font-bold text-[#212121] mb-3 flex items-center gap-2">
            <i className="ri-file-text-line text-[#1565C0]"></i>
            وصف المشكلة
          </h3>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="اشرح المشكلة بالتفصيل..."
            className="w-full bg-[#F6F6F6] rounded-xl p-3 outline-none text-sm resize-none"
            rows={4}
            maxLength={500}
          />
          <div className="text-left text-xs text-gray-400 mt-1">
            {description.length}/500
          </div>
        </div>

        {/* Image Upload */}
        <div className="bg-white rounded-2xl p-5 shadow-md mb-4 animate-slideUp stagger-5">
          <h3 className="font-bold text-[#212121] mb-3 flex items-center gap-2">
            <i className="ri-image-line text-[#1565C0]"></i>
            رفع صور إضافية
          </h3>
          
          <div className="grid grid-cols-4 gap-2">
            {images.map((img, index) => (
              <div key={index} className="relative aspect-square rounded-lg overflow-hidden">
                <img src={img} alt="" className="w-full h-full object-cover" />
                <button
                  onClick={() => setImages(images.filter((_, i) => i !== index))}
                  className="absolute top-1 left-1 w-5 h-5 bg-red-500 rounded-full flex items-center justify-center"
                >
                  <i className="ri-close-line text-white text-xs"></i>
                </button>
              </div>
            ))}
            
            {images.length < 4 && (
              <label className="aspect-square bg-[#F6F6F6] rounded-lg flex flex-col items-center justify-center cursor-pointer border-2 border-dashed border-gray-300">
                <i className="ri-add-line text-gray-400 text-2xl"></i>
                <span className="text-xs text-gray-400 mt-1">إضافة</span>
                <input
                  type="file"
                  accept="image/*"
                  multiple
                  onChange={handleImageUpload}
                  className="hidden"
                />
              </label>
            )}
          </div>
        </div>
      </div>

      {/* Submit Button */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 p-4 shadow-lg">
        <button
          onClick={handleSubmit}
          className="w-full bg-gradient-to-l from-[#1565C0] to-[#2E7D32] text-white py-4 rounded-xl font-bold shadow-lg hover:shadow-xl transition-all active:scale-[0.98]"
        >
          إرسال الطلب
        </button>
      </div>
    </div>
  );
}
